/**
 * Workflow API Client
 * Typed client for the 4 workflow endpoints under /landlord/api/workflows
 */

import { apiFetch } from './api.core';
import type { WorkflowListItem, EnsureWorkflowInput } from '../types/workflow';

/**
 * GET /landlord/api/workflows
 * Returns all active and recently-dismissed workflows for the current manager.
 * Items are a discriminated union on `kind`: sagas (move-in) and standalone atomics.
 */
export async function listWorkflows(): Promise<{ workflows: WorkflowListItem[] }> {
  return apiFetch('/landlord/api/workflows');
}

/**
 * POST /landlord/api/workflows/:id/dismiss
 * Dismiss a saga-level workflow so it no longer appears in the active panel.
 */
export async function dismissWorkflow(id: string): Promise<void> {
  await apiFetch(`/landlord/api/workflows/${id}/dismiss`, { method: 'POST' });
}

/**
 * POST /landlord/api/workflows/:id/restore
 * Restore a previously dismissed workflow.
 */
export async function restoreWorkflow(id: string): Promise<void> {
  await apiFetch(`/landlord/api/workflows/${id}/restore`, { method: 'POST' });
}

/**
 * POST /landlord/api/workflows/ensure
 * Ensure a workflow exists for the given input (idempotent via dedupeKey).
 */
export async function ensureWorkflow(input: EnsureWorkflowInput): Promise<{ id: string }> {
  return apiFetch('/landlord/api/workflows/ensure', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
